import z from "zod";
import { worksites } from "../../attendances";
import { moment } from "../../date";

export const editAttendanceFormSchema = z
	.object({
		startTime: z.string(),
		endTime: z.string().nullable(),
		worksite: z.enum(worksites),
		projectId: z.uuid().nullish(),
	})
	.transform((values) => {
		const keys = ["startTime", "endTime"] as const;
		for (const key of keys) {
			if (values[key]) {
				const parts = values[key].split(":");
				const hours = parts[0]?.padStart(2, "0") || "00";
				const minutes = (parts[1] || "00").padStart(2, "0");
				const seconds = (parts[2] || "00").padStart(2, "0");
				values[key] = `${hours}:${minutes}:${seconds}`;
			}
		}
		return values;
	})
	.superRefine((values, context) => {
		if (values.endTime) {
			const startTime = moment().setTime(values.startTime);
			const endTime = moment().setTime(values.endTime);
			if (endTime.isBefore(startTime)) {
				context.addIssue({
					code: "custom",
					path: ["endTime"],
					message: "End-Time must be after Start-Time",
				});
			}
		}
	});

export type EditAttendanceFormSchema = z.infer<typeof editAttendanceFormSchema>;
